import React from 'react'
import { connect } from 'react-redux';
import ResetPasswordForm from './forms/ResetPasswordForm';

const ResetPasswordPage = (props) => {
    return (
        <div className="container-fluid container-form" >
            <ResetPasswordForm />
        </div>
    )
}

const mapStateToProps = (state) => {
    return {
    }
}

export default connect(mapStateToProps)(ResetPasswordPage);